/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * A single tool entry in a tool metadata batch.
 */
export type ToolMetadataForm = {
  /**
   * Hint that the tool may perform destructive updates to its environment
   */
  destructiveHint?: boolean | undefined;
  /**
   * Hint that calling the tool repeatedly with the same arguments has no additional effect
   */
  idempotentHint?: boolean | undefined;
  /**
   * Hint that the tool may interact with an open world of external entities
   */
  openWorldHint?: boolean | undefined;
  /**
   * Hint that the tool does not modify its environment
   */
  readOnlyHint?: boolean | undefined;
  /**
   * A human-readable title for the tool
   */
  title?: string | undefined;
  /**
   * The name of the tool
   */
  toolName: string;
};

/** @internal */
export type ToolMetadataForm$Outbound = {
  destructive_hint?: boolean | undefined;
  idempotent_hint?: boolean | undefined;
  open_world_hint?: boolean | undefined;
  read_only_hint?: boolean | undefined;
  title?: string | undefined;
  tool_name: string;
};

/** @internal */
export const ToolMetadataForm$outboundSchema: z.ZodMiniType<
  ToolMetadataForm$Outbound,
  ToolMetadataForm
> = z.pipe(
  z.object({
    destructiveHint: z.optional(z.boolean()),
    idempotentHint: z.optional(z.boolean()),
    openWorldHint: z.optional(z.boolean()),
    readOnlyHint: z.optional(z.boolean()),
    title: z.optional(z.string()),
    toolName: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      destructiveHint: "destructive_hint",
      idempotentHint: "idempotent_hint",
      openWorldHint: "open_world_hint",
      readOnlyHint: "read_only_hint",
      toolName: "tool_name",
    });
  }),
);

export function toolMetadataFormToJSON(
  toolMetadataForm: ToolMetadataForm,
): string {
  return JSON.stringify(
    ToolMetadataForm$outboundSchema.parse(toolMetadataForm),
  );
}
